import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8l-4 4l4 4","key":"svg-0"}],["path",{"d":"M17 8l4 4l-2.5 2.5","key":"svg-1"}],["path",{"d":"M14 4l-1.201 4.805m-.802 3.207l-2 7.988","key":"svg-2"}],["path",{"d":"M3 3l18 18","key":"svg-3"}]]

const IconCodeOff = createReactComponent('outline', 'code-off', 'CodeOff', __iconNode);

export default IconCodeOff;